import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { useState, useEffect } from 'react';
import { Colors } from '@lean-body/components/styles';
import { LocalStorage, LocalStorageType } from '@lean-body/src/infra';
import { GOAL_MATCHING_ASSESSMENT_VERSION } from '../pages/main_goal_matching_assessment';
import { DiagnosisStepFooter } from '../molecules';
import { PageLoading } from './page_loading';
import { GoalMatchingAssessmentHeader } from '../molecules/goal_matching_assessment_header';
import { MatchingAssessmentDiagnosisPlanAnalyzedResult } from './matching_assessment_diagnosis_plan_analyzed_result';
import { MatchingAssessmentDiagnosisPlanAnalyzing } from './matching_assessment_diagnosis_plan_analyzing';
export const MatchingAssessmentDiagnosisPlanResult = ({ apiClient, tracker, userName, currentWeight, currentAnswers, isWeightKeeping, onBack, onComplete, }) => {
    const localStorage = new LocalStorage();
    const [result, setResult] = useState();
    const [isLoading, setIsLoading] = useState(true);
    const [isAnalyzingCompleted, setIsAnalyzingCompleted] = useState(false);
    const diagnosisParams = localStorage.loadMatchingAssessmentDiagnosisParams();
    useEffect(() => {
        const params = {
            answers: currentAnswers.filter(Boolean),
            version: GOAL_MATCHING_ASSESSMENT_VERSION,
            courseCode: localStorage.loadObjByKey(LocalStorageType.CourseCode),
        };
        const fetchResult = apiClient.fetchGoalMatchingAssessmentResultUnauthenticated(params);
        fetchResult.then((res) => {
            setResult(res);
            setIsLoading(false);
            localStorage.removeKey(LocalStorageType.CourseCode);
            tracker === null || tracker === void 0 ? void 0 : tracker.trackDiagnosisComplete();
        });
    }, []);
    useEffect(() => {
        if (!isAnalyzingCompleted)
            return;
        tracker === null || tracker === void 0 ? void 0 : tracker.trackDiagnosisPlanGenerated();
    }, [isAnalyzingCompleted]);
    const onClickPlanCTA = () => {
        onComplete();
    };
    if (isLoading || !result) {
        return React.createElement(PageLoading, null);
    }
    return (React.createElement("div", { className: css(styles.container) },
        React.createElement(GoalMatchingAssessmentHeader, { classObject: styles.header, onClickBack: onBack, hideProgress: true }),
        !isAnalyzingCompleted ? (React.createElement(MatchingAssessmentDiagnosisPlanAnalyzing, { onCompleteAnalyzing: () => setIsAnalyzingCompleted(true) })) : (React.createElement(React.Fragment, null,
            React.createElement(MatchingAssessmentDiagnosisPlanAnalyzedResult, { userName: userName, isWeightKeeping: isWeightKeeping, currentWeight: currentWeight, weightGoal: result.weightGoal, goalDateUnix: Number(result.goalDate), diagnosisParams: diagnosisParams }),
            React.createElement(DiagnosisStepFooter, { isDisabled: false, onNext: onClickPlanCTA, buttonText: "\u30D7\u30E9\u30F3\u3092\u5165\u624B" })))));
};
const styles = StyleSheet.create({
    container: {
        position: 'relative',
        width: '100%',
        minHeight: '100vh',
        backgroundImage: Colors.BackgroundAi,
        overflow: 'hidden',
        paddingBottom: 150,
    },
    header: {
        marginTop: 16,
        marginLeft: 24,
        marginRight: 24,
    },
});
